import {
  RECEIVE_SETTINGS,
  RESET_SETTINGS,
  RECEIVE_USER,
} from "./actions/Session";
import { PAGE } from "./actions/Page";
import BluLicense from "lib/license";

const initialState = BluLicense;

const LicenseReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case RECEIVE_SETTINGS: {
      if (
        action.settings.userOrgs &&
        !BluLicense.orgId &&
        action.settings.userOrgs.length > 0
      ) {
        BluLicense.orgId = action.settings.userOrgs[0].id;
      }
      BluLicense.setLicenseMap(action.settings.userOrgs);
      return BluLicense;
    }
    case RESET_SETTINGS: {
      return BluLicense;
    }
    case RECEIVE_USER: {
      return BluLicense;
    }
    case PAGE: {
      BluLicense.orgId = action.payload.orgId;
      return BluLicense;
    }
    default:
      return state;
  }
};

export default LicenseReducer;
